import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  TrackerShoppingListConnectorApollo,
  TrackerShoppingListMarkItemConnectorApollo,
  useTranslator,
} from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';
import TrackerShoppingListContainer from './TrackerShoppingListContainer';

interface Props {
  shoppingTipsArticleId: number;
}

/** Tracker shopping list: products logged in a date range, opened from the tracker details. */
const TrackerShoppingListPage: React.FC<Props> = ({ shoppingTipsArticleId }) => {
  const { t } = useTranslator();
  // react-slide-routes keeps tracker pages mounted between visits; keying on the location
  // remounts the data layer on each visit, so it refetches and tracks a fresh screen view.
  const { key: visitKey } = useLocation();

  return (
    <Layout>
      <TitleBar>{t('shoppingList.navbarTitle')}</TitleBar>
      <div className="page-template-shopping-list">
        <TrackerShoppingListConnectorApollo key={visitKey}>
          {({ loading, shoppingList, showRange }) => (
            <TrackerShoppingListMarkItemConnectorApollo>
              {({ markItem }) => (
                <TrackerShoppingListContainer
                  loading={loading}
                  shoppingList={shoppingList}
                  showRange={showRange}
                  markItem={markItem}
                  shoppingTipsArticleId={shoppingTipsArticleId}
                />
              )}
            </TrackerShoppingListMarkItemConnectorApollo>
          )}
        </TrackerShoppingListConnectorApollo>
      </div>
    </Layout>
  );
};

export default TrackerShoppingListPage;
